import type { OrderingBrandSettings } from '@sevenrooms/domain'
import { useStoreSelector } from '../store'

export function useOrderingBrandSettings(): OrderingBrandSettings {
  return useStoreSelector(state => state.venue.orderingBrandSettings)
}
